// ─── Storage Keys ─────────────────────────────────────────────────────────────
export const KEYS = {
  COLLECTION : 'fslp:collection',
  CHILDREN   : 'fslp:children',
  PROGRESS   : 'fslp:progress',
  WORK_PLANS : 'fslp:workplans',
  ACTIVITY   : 'fslp:activity',
  SETTINGS   : 'fslp:settings',
  META       : 'fslp:meta',
}

// ─── Storage helpers ──────────────────────────────────────────────────────────
export async function sGet(key, fallback = null) {
  try {
    const r = await window.storage.get(key)
    return r ? JSON.parse(r.value) : fallback
  } catch {
    return fallback
  }
}

export async function sSet(key, value) {
  try {
    await window.storage.set(key, JSON.stringify(value))
    return true
  } catch {
    return false
  }
}

export async function sDel(key) {
  try {
    await window.storage.delete(key)
    return true
  } catch {
    return false
  }
}
